import Coordinate from "./Coordinate";

export default class RectCoordinate extends Coordinate {
    constructor(provider, absX, absY, parent) {
        super(provider, absX, absY);
        this.parent = parent;
    }

    setRelations(horizontal, vertical) {
        this.horizontal = horizontal;
        this.vertical = vertical;
    }

    drag() {
        this.horizontal.updatePositions();
        this.vertical.updatePositions();

        this.parent.updateCorners();
        this.parent.row.updateImg();
        this.updateInputs();
    }

    mouseOver(viewX, viewY) {
        if (!this.hovered(viewX, viewY)) {
            return false;
        }

        this.setCursor();
        return true;
    }

    updateInputs() {
        this.getTab('info').input.width.value(this.calculatePixelToDisplayDistance(this.parent.width));
        this.getTab('info').input.height.value(this.calculatePixelToDisplayDistance(this.parent.height));
    }

    setCursor() {
        return (this.absX >= 0
            && this.absY >= 0)
            || (this.absX <= 0
                && this.absY <= 0)
            ? this.cursor.resizeNWSE(this.parent.rotation)
            : this.cursor.resizeNESW(this.parent.rotation);
    }

    get realX() {
        let angle = Math.atan2(this.absY, this.absX) + this.parent.rotation;
        let length = Math.sqrt(this.currentX ** 2 + this.currentY ** 2);
        return this.parent.currentX + length * Math.cos(angle);
    }

    get realY() {
        let angle = Math.atan2(this.absY, this.absX) + this.parent.rotation;
        let length = Math.sqrt(this.currentX ** 2 + this.currentY ** 2);
        return this.parent.currentY + length * Math.sin(angle);
    }
}
